<footer class="fixed-bottom">
    <div class="row">
        <div class="p-5 col-12">
            <p>© 2023 {{env.copyRight}}, Inc.</p>
            All rights reserved.
        </div>
    </div>
</footer>